module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_02@2x-7238aba618fc325aa0f124d2e79b7d91.webp";